import React from 'react';
import { Link } from 'react-router-dom';
import { FileCheck2, ArrowRight } from 'lucide-react';

const STATUS_STYLES = {
  'In Stock': 'text-emerald-300/90 border-emerald-300/30',
  Preorder: 'text-alp-gold border-alp-gold/40',
  'Out of Stock': 'text-alp-gray border-alp-gray/30',
};

export default function ProductCard({ product }) {
  const out = product.stockStatus === 'Out of Stock';
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group relative block bg-alp-card/80 border border-alp-line rounded-lg overflow-hidden card-modern"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-alp-dark">
        <div aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-alp-gold/50 to-transparent z-10" />
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className={`w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06] ${
            out ? 'opacity-40 grayscale' : ''
          }`}
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-alp-black/70 to-transparent pointer-events-none" />
        <span
          className={`absolute top-3 left-3 text-[10px] tracking-[0.18em] uppercase px-3 py-1 rounded-full bg-alp-black/70 backdrop-blur-sm border ${
            STATUS_STYLES[product.stockStatus] || ''
          }`}
        >
          {product.stockStatus}
        </span>
        {product.ribbon ? (
          <span className="absolute bottom-3 left-3 text-[10px] tracking-[0.15em] uppercase px-3 py-1 rounded-full bg-alp-gold text-alp-black font-semibold shadow-[0_2px_14px_rgba(212,180,131,0.45)]">
            {product.ribbon}
          </span>
        ) : null}
        {product.coa && (
          <span className="absolute top-3 right-3 flex items-center gap-1 text-[10px] tracking-[0.12em] uppercase px-2.5 py-1 rounded-full bg-alp-black/70 backdrop-blur-sm border border-alp-gold/40 text-alp-gold">
            <FileCheck2 size={11} strokeWidth={1.8} /> COA
          </span>
        )}
        <span className="quickview-bar absolute inset-x-0 bottom-0 hidden sm:flex items-center justify-center gap-2 bg-alp-gold text-alp-black text-[11px] tracking-[0.22em] uppercase font-semibold py-3">
          View Product <ArrowRight size={13} />
        </span>
      </div>
      <div className="p-5">
        <div className="text-[10px] tracking-[0.25em] uppercase text-alp-gray mb-1.5">
          {product.category}
        </div>
        <h3 className="font-serif text-xl text-alp-cream leading-snug group-hover:text-alp-gold transition-colors duration-300">
          {product.name}
        </h3>
        <div className="text-alp-gray text-xs mt-1 tracking-[0.08em]">{product.size}</div>
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-alp-line/60">
          <span className="flex items-baseline gap-2">
            <span className="text-alp-gold text-lg font-medium">${product.price.toFixed(2)}</span>
            {product.compareAtPrice > product.price && (
              <span className="text-alp-gray/70 text-sm line-through">${product.compareAtPrice.toFixed(2)}</span>
            )}
            <span className="text-alp-gray/70 text-[10px] tracking-[0.15em] uppercase">AUD</span>
          </span>
          <span className="sm:opacity-60 sm:group-hover:opacity-0 text-xs tracking-[0.18em] uppercase text-alp-cream/70 transition-opacity duration-300">
            View &rarr;
          </span>
        </div>
      </div>
    </Link>
  );
}
